import React from 'react';

import Logo from '../../Logo';
import '../NavbarVariant.css';

const EmptyNavbar = () => (
  <div className="pdx-global-navbar overflow-hidden navbar-variant">
    <nav className="navbar navbar-expand-lg">
      <Logo />
    </nav>
  </div>
);

export default EmptyNavbar;
